export default __webpack_public_path__ + "static/media/slide1.508ef3f9.webp";